module.exports = __webpack_public_path__ + "media/src/images/icons/gift_in_circle-ac1e8b2aff89200fdfb053fe49e91a9e.svg";